/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdDomainSettingsAdvertisementWeChatOptions
 */
export interface FxIdDomainSettingsAdvertisementWeChatOptions {
    /**
     * 
     * @type {string}
     * @memberof FxIdDomainSettingsAdvertisementWeChatOptions
     */
    RewardedVideoAdId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FxIdDomainSettingsAdvertisementWeChatOptions
     */
    InterstitialAdId?: string | null;
    /**
     * https://developers.weixin.qq.com/minigame/dev/guide/open-ability/ad/rewarded-video-ad.html#_1004-%E5%85%9C%E5%BA%95%E5%88%86%E4%BA%AB%E9%A1%B5
     * @type {boolean}
     * @memberof FxIdDomainSettingsAdvertisementWeChatOptions
     */
    DisableFallbackSharePage: boolean;
}

/**
 * Check if a given object implements the FxIdDomainSettingsAdvertisementWeChatOptions interface.
 */
export function instanceOfFxIdDomainSettingsAdvertisementWeChatOptions(value: object): value is FxIdDomainSettingsAdvertisementWeChatOptions {
    if (!('DisableFallbackSharePage' in value) || value['DisableFallbackSharePage'] === undefined) return false;
    return true;
}

export function FxIdDomainSettingsAdvertisementWeChatOptionsFromJSON(json: any): FxIdDomainSettingsAdvertisementWeChatOptions {
    return FxIdDomainSettingsAdvertisementWeChatOptionsFromJSONTyped(json, false);
}

export function FxIdDomainSettingsAdvertisementWeChatOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsAdvertisementWeChatOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'RewardedVideoAdId': json['RewardedVideoAdId'] == null ? undefined : json['RewardedVideoAdId'],
        'InterstitialAdId': json['InterstitialAdId'] == null ? undefined : json['InterstitialAdId'],
        'DisableFallbackSharePage': json['DisableFallbackSharePage'],
    };
}

export function FxIdDomainSettingsAdvertisementWeChatOptionsToJSON(json: any): FxIdDomainSettingsAdvertisementWeChatOptions {
    return FxIdDomainSettingsAdvertisementWeChatOptionsToJSONTyped(json, false);
}

export function FxIdDomainSettingsAdvertisementWeChatOptionsToJSONTyped(value?: FxIdDomainSettingsAdvertisementWeChatOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'RewardedVideoAdId': value['RewardedVideoAdId'],
        'InterstitialAdId': value['InterstitialAdId'],
        'DisableFallbackSharePage': value['DisableFallbackSharePage'],
    };
}

